module.exports = __webpack_public_path__ + "media/images/favicons/270px-f02270fdaf1832d895f525aded71cd11.png";